import { legacy_createStore as createStore, applyMiddleware } from "redux";
import { combineReducers } from "redux";
import thunk from "redux-thunk";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import loginReducer from "./modules/login/redux/reducer";
import dashboardReducer from "./modules/dashboard/redux/reducer";
import homeReducer from "./modules/home/redux/reducer";
import userdashboardReducer from "./modules/user/dashboard/redux/reducer";
import { language } from "./modules/header/redux/reducer";
import headerContent from "./modules/seoroute/redux/reducer";
import Chat from "./modules/chat/redux/reducer";


const persistConfig = {
  key: "persist-store",
  storage,
};

const middleware = [thunk];

const rootReducer = combineReducers({
  login: loginReducer,
  languageState: language,
  home: homeReducer,
  dashboard: dashboardReducer,
  userdashboard: userdashboardReducer,
  headerContent: headerContent,
  Chat: Chat
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

//const store = createStore(rootReducer, applyMiddleware(...middleware));

const store = createStore(persistedReducer, applyMiddleware(...middleware));

export const persistor = persistStore(store);

// const store = createStore(loginReducer,intialState,applyMiddleware(...middleware));

export default store;
